// extracted by mini-css-extract-plugin
module.exports = {"title":"e_zkb","excerpt":"e_Akb","container":"e_Bkb","imageContainer":"e_Ckb","image":"e_Dkb","postedBy":"e_Ekb","postedByDate":"e_Fkb"};